// extracted by mini-css-extract-plugin
export default {"root":"SellBlock-root","body":"SellBlock-body","actions":"SellBlock-actions","action":"SellBlock-action"};